import "./style.css";

export const HorizontalNavigation = ({ options, callback, tabActive }) => {
  return (
    <div className="horizontalNavigation">
      <div className="horizontalNavigationContainer">
        {options?.map((button) => (
          <button
            key={button.tab}
            type="button"
            className={`customButton ${tabActive === button.tab ? "customButtonColor2" : "customButtonColor1"}`}
            disabled={button.disabled}
            aria-pressed={tabActive === button.tab}
            title={button.disabled ? "Guarda primero el producto para configurar esta sección" : undefined}
            onClick={() => callback(button.tab)}
          >{button.icon}<span className="customButtonText">{button.text}</span></button>
        ))}
      </div>
    </div>
  );
};
